import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ConfigService } from 'services/config/config.service';
import { DownloadFormat } from 'services/download/download.enumerations';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {

    constructor(private configService: ConfigService, private http: HttpClient) {}

    GetAvailableReports(AuthToken: string, CurrentRole: string, AwardID: number) {
        return this.http.get<ReportInfo[]>(this.configService.hostAddress +
            `Api/Services/Report/GetAvailableReports?AuthToken=${AuthToken || ''}&` +
            `Role=${CurrentRole || ''}&AwardID=${AwardID || ''}`);
    }

}


export class ReportInfo {
    CanSetSchool?: boolean;
    CanSetJudgingPhase?: boolean;
    CanSetNomType?: boolean;
    Description?: string;
    ReportID?: number;
    ReportFileType: DownloadFormat;
    SortOrder: number;
    Title: string;
}
